import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { RemoveTrustedDeviceData } from 'src/app/shared/models/DeviceInfoResponse';
import { GdlService } from 'src/app/shared/services/gdl-service/gdl.service';

@Component({
  selector: 'wpro-remove-trusted-device',
  templateUrl: './remove-trusted-device.component.html',
  styleUrls: ['./remove-trusted-device.component.css'],
  standalone: false
})
export class RemoveTrustedDeviceComponent implements OnChanges {
  @Input() showDeletePopUp: RemoveTrustedDeviceData;
  @Output() isRemoveDevice = new EventEmitter<boolean>();
  show = false;
  deleteMultiple: boolean;
  categoryName = 'modal';

  constructor(private gdlService: GdlService) {}

  ngOnChanges(): void {
    this.deleteMultiple = false;
    if(this.showDeletePopUp?.isDoNotShowPopupChecked){
      this.showClosePopup('');
    }
    if(this.showDeletePopUp?.deviceId.includes(',')){
      this.deleteMultiple = true;
    }
    if (this.show) {
      (this.deleteMultiple) ? this.captureGdlClickForPopUp('open', 'wpro-loginsecurity-removealldevices-modal')
      : this.captureGdlClickForPopUp('open', 'wpro-loginsecurity-deletedevice-modal');
    }
  }

  showClosePopup(action: string): void {
    if(action === 'cancelBtn') {
      (this.deleteMultiple) ? this.captureGdlClickForPopUp('dismiss', 'wpro-loginsecurity-removealldevices-cancel')
      : this.captureGdlClickForPopUp('dismiss', 'wpro-loginsecurity-deletedevice-cancel');
    } else if(action === 'crossBtn') {
      (this.deleteMultiple) ? this.captureGdlClickForPopUp('dismiss', 'wpro-loginsecurity-removealldevices-close')
      : this.captureGdlClickForPopUp('dismiss', 'wpro-loginsecurity-deletedevice-close');
    }
    this.show = !this.show;
  }

  captureGdlClickForPopUp(formName: string, eventNameGdl: string): void {
    this.gdlService.triggerGdlLogEvent(this.categoryName, formName, { name: eventNameGdl });
  }

  deleteDevice(): void {
    (this.deleteMultiple) ? this.captureGdlClickForPopUp('confirm', 'wpro-loginsecurity-removealldevices')
      : this.captureGdlClickForPopUp('confirm', 'wpro-loginsecurity-deletedevice');
    this.showClosePopup('');
    this.isRemoveDevice.emit(true);
  }
}
